import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/imgSegment/actions';

class ImageSegmentAckTaskEnd extends Component {
    componentDidMount(){
        if (this.props.imgSegment.taskCompleted){
            this.props.taskCompleted();
        }
    }
    render() {
        const { imgSegment } = this.props;
        
        return (
            <div className="container">
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <h4>{imgSegment.task.task_name}</h4>
                    </div>    
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <blockquote className="blockquote text-left">
                            <h4 className="display-4">Thank you</h4>
                            <p className="mb-0">Your task has been submitted successfully.</p>
                            <footer className="blockquote-footer">Team at <cite title="Source Title">Swarm Colony</cite></footer>
                        </blockquote>
                    </div>    
                </div>    
            </div>    
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        imgSegment: state.imgSegment
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      taskCompleted: () => {
          dispatch(actions.taskCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ImageSegmentAckTaskEnd);


// WEBPACK FOOTER //
// ./src/views/ImageSegmentQuestion/ImageSegmentAckTaskEnd.js